import { useEffect, useState } from "react";
import { Activity, ShieldCheck, Receipt, Tags, FileText, Inbox, UserCog, Plug } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Card, Loader } from "@/components/portal/ui";

const ICON = {
  provider: ShieldCheck, invoice: Receipt, category: Tags, document: FileText,
  inquiry: Inbox, membership: UserCog, connector: Plug, config: UserCog,
};

function iconFor(action = "") {
  const key = String(action).split(".")[0];
  return ICON[key] || Activity;
}

function rel(iso, L) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return L({ de: "gerade eben", fr: "à l'instant", it: "poco fa", en: "just now" });
  if (s < 3600) return `${Math.floor(s / 60)} min`;
  if (s < 86400) return `${Math.floor(s / 3600)} h`;
  return d.toLocaleDateString();
}

export function ActivityView() {
  const { L } = useI18n();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/activity").then(({ data }) => setItems(data)); }, []);
  if (!items) return <Loader />;

  return (
    <div data-testid="activity-view">
      {items.length === 0 ? (
        <Card className="p-12 flex flex-col items-center gap-3 text-center">
          <Activity className="h-8 w-8" style={{ color: "var(--accent)" }} />
          <span style={{ color: "var(--text-muted)" }}>{L({ de: "Noch keine Aktivität.", fr: "Aucune activité.", it: "Nessuna attività.", en: "No activity yet." })}</span>
        </Card>
      ) : (
        <Card className="p-2">
          <div className="divide-y" style={{ borderColor: "var(--border)" }}>
            {items.map((it, i) => {
              const I = iconFor(it.action);
              return (
                <div key={it.id || i} className="flex items-center gap-3 p-3" data-testid={`activity-item-${i}`}>
                  <div className="h-9 w-9 shrink-0 flex items-center justify-center" style={{ background: "var(--surface-alt)", borderRadius: "var(--radius)" }}>
                    <I className="h-4 w-4" style={{ color: "var(--accent)" }} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm truncate" style={{ color: "var(--text)" }}>
                      <span className="font-medium">{it.actor_name}</span> · <span style={{ color: "var(--text-muted)" }}>{it.action}</span>
                    </div>
                  </div>
                  <span className="text-xs whitespace-nowrap" style={{ color: "var(--text-muted)" }}>{rel(it.created_at, L)}</span>
                </div>
              );
            })}
          </div>
        </Card>
      )}
    </div>
  );
}
